import type { CSSProperties } from 'react';
import type { ButtonProps } from '../../types';
import { ACCENT, ACCENT_HOVER, EASE, SURFACE2 } from '../../tokens';

/** Primary filled CTA. Hover state is applied imperatively to keep the DOM light. */
export function Btn({ href = '#', onClick, children, style = {}, target }: ButtonProps) {
  const base: CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    background: ACCENT,
    color: SURFACE2,
    textDecoration: 'none',
    padding: '15px 30px',
    borderRadius: 100,
    fontSize: '0.95rem',
    fontWeight: 600,
    letterSpacing: '-0.01em',
    border: 'none',
    cursor: 'pointer',
    transition: `transform 0.3s ${EASE}, background 0.2s, box-shadow 0.3s`,
    ...style,
  };

  return (
    <a
      href={href}
      onClick={onClick}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      style={base}
      onMouseEnter={(e) => {
        const el = e.currentTarget;
        el.style.transform = 'scale(1.04) translateY(-2px)';
        el.style.background = ACCENT_HOVER;
        el.style.boxShadow = '0 8px 28px rgba(255,107,0,0.35)';
      }}
      onMouseLeave={(e) => {
        const el = e.currentTarget;
        el.style.transform = 'scale(1) translateY(0)';
        el.style.background = ACCENT;
        el.style.boxShadow = 'none';
      }}
    >
      {children}
    </a>
  );
}
